import React, { Component } from "react";
import "whatwg-fetch";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Web2DeskCreate from "./components/web2desk/create";
import Web2DeskDownload from "./components/web2desk/download";
import Pwa2Apk from "./components/pwa2apk";
import Playground from "./components/playground";

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Route exact path="/" component={Pwa2Apk} />
          <Route exact path="/playground" component={Playground} />
          <Route path="/pwa-to-apk" component={Pwa2Apk} />

          <Route path="/web2desk" exact component={Web2DeskCreate} />
          <Route
            path="/web2desk/download/:appId"
            exact
            component={Web2DeskDownload}
          />
        </div>
      </Router>
    );
  }
}

export default App;
